import { ThreadList } from './ThreadList';
import { Conversation } from './Conversation';
import { usePhone } from '@/state/phone';

export function Phone() {
  const activeThreadId = usePhone((s) => s.activeThreadId);
  return (
    <div className="flex h-full flex-col bg-[var(--bg-deep)]">
      {activeThreadId ? <Conversation threadId={activeThreadId} /> : <ThreadList />}
    </div>
  );
}
